
          <div class="cust-width">
            <div class="table-container">
              <table class="table">
                <thead>
                  <tr>
                    <th>S/N</th>
                    <th>Application Type</th>
                    <th>Building Type</th>
                    <th>Building Sub Type</th>
                    <th>Volume of Building</th>
                    <th>Plot No</th>
                    <th>Name of Layout</th>
                    <th>Survey Plan Number</th>
                    <th>Layout Status</th>
                    <th>Area of Plot</th>
                    <th>Application Fees</th>
                    <th>Payment Status</th>
                  </tr>
                </thead>

                <tbody *ngIf="data?.length > 0">
                  <tr *ngFor="let eachDetail of data; let i = index">
                    <td>{{ i + 1 }}</td>
                    <td>{{ eachDetail?.application_type || '--' }}</td>
                    <td>{{ eachDetail?.building_type || '--' }}</td>
                    <td>{{ eachDetail?.building_sub_type || '--' }}</td>
                    <td>{{ eachDetail?.volume_of_building || '--' }}</td>
                    <td>{{ eachDetail?.plot_number || '--' }}</td>
                    <td>{{ eachDetail?.name_of_layout || '--' }}</td>
                    <td>{{ eachDetail?.survey_plan_number || '--' }}</td>
                    <td>{{ eachDetail?.layout_status || '--' }}</td>
                    <td>{{ eachDetail?.area_of_plot || '--' }}</td>

                    <td>{{ eachDetail?.application_fee | nairaCurrency }}</td>

                    <td [ngClass]="{
                        'not-paid': eachDetail?.payment_status === 'NOT_PAID',
                        paid: eachDetail?.payment_status === 'PAID'
                      }">
                      {{ eachDetail?.payment_status | removeUnderscores }}
                    </td>
                  </tr>
                </tbody>

                
              </table>

              <div class="p-3">
                <p class="text-center" *ngIf="!data && !(resultsEmpty || error)">Loading... Please Wait...</p>
                <p class="text-center text-danger" *ngIf="resultsEmpty" >No data available</p>
                <p class="text-center text-danger" *ngIf="error">Error fetching data</p>
              </div>
              <div class="d-flex justify-content-between align-items-center mt-3">
                <div class="d-flex align-items-center">
                  <label for="pageSize" class="me-2 fw-semibold">Page Size:</label>
                  <select id="pageSize" class="form-select form-select-sm" style="width: auto" [(ngModel)]="pageSize"
                    (change)="onPageSizeChange()">
                    <option *ngFor="let size of pageSizeOptions" [value]="size">
                      {{ size }}
                    </option>
                  </select>
                </div>

                <ngb-pagination class="my-3" [(page)]="currentPage" [pageSize]="pageSize" [collectionSize]="count"
                  [maxSize]="5" [boundaryLinks]="true" [directionLinks]="true" (pageChange)="fetchInfo()">
                </ngb-pagination>
              </div>
            </div>

          </div>
      